const getFileName = (disposition) => {
    let filename = disposition;
    if (disposition && disposition.indexOf('attachment') !== -1) {
        var filenameRegex = /filename\*?=([^']*'')?([^;]*)/
        var matches = filenameRegex.exec(disposition)
        if (matches != null && matches[2]) {
            filename = decodeURIComponent(matches[2].replace(/['"]/g, ''))
        }
    }
    return filename
}

const fileDownload = async (response) => {

    if (!(response.data instanceof Blob))
        return response.data

    if (response.data.type === 'application/json') {
        try {
            let resText = await new Promise((resolve, reject) => {
                let reader = new FileReader()
                reader.addEventListener('abort', reject)
                reader.addEventListener('error', reject)
                reader.addEventListener('loadend', () => {
                    resolve(reader.result)
                })
                reader.readAsText(response.data)
            })
            return JSON.parse(resText)
        }
        catch (err) {
            return response.data
        }
    }
    else {
        return { file: new Blob([response.data]), filename: getFileName(response.headers['content-disposition']) }
    }
}

export default fileDownload